module.exports = __webpack_public_path__ + "static/img/pa.d0787677.svg";